/*-----------------------------------------------------------------
- Breadcrumbs translations
-----------------------------------------------------------------*/
export default {
    
    commenting    : 'Comments',
    comment_single: 'View Comment',
    
};
